import { connect } from "react-redux";
import colores from "../../shared/constants/styles";
import Dialog from "@mui/material/Dialog";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

const titles = {
  fontWeight: "bold",
  fontSize: "1.1rem",
  marginBottom: "0.5rem",
  padding: "0",
};

interface PedidoFirmeProps {
  open: boolean;
  handleNext: () => void;
  handleSelectPedidoFirma: (event: React.ChangeEvent<HTMLInputElement>) => void;
  mostrarAlertaImpuestos: boolean;
  esPedidoFirme: boolean | null;
}

const PedidoFirme = (props: PedidoFirmeProps) => {
  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            marginBottom: "1rem",
            padding: "0",
            color: "#222",
          }}
        >
          SELECCIONE EL TIPO DE OPERACIÓN*
        </DialogContentText>

        <FormControl fullWidth>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            onChange={props.handleSelectPedidoFirma}
          >
            <div style={{ marginBottom: "1rem" }}>
              <FormControlLabel
                value="1"
                control={<Radio />}
                style={{
                  alignItems: "flex-start",
                  margin: 0,
                }}
                label={
                  <div>
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                      }}
                    >
                      Pedido de venta firme
                    </div>

                    <div
                      style={{
                        fontSize: "1rem",
                        marginTop: "0.25rem",
                        color: "#555",
                      }}
                    >
                      Compra confirmada que autoriza el procesamiento del
                      pedido.
                    </div>
                  </div>
                }
              />
            </div>

            <div>
              <FormControlLabel
                value="0"
                control={<Radio />}
                style={{
                  alignItems: "flex-start",
                  margin: 0,
                }}
                label={
                  <div>
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                      }}
                    >
                      Presupuesto
                    </div>

                    <div
                      style={{
                        fontSize: "1rem",
                        marginTop: "0.25rem",
                        color: "#555",
                      }}
                    >
                      Cotización informativa que no confirma la compra ni genera
                      un pedido.
                    </div>
                  </div>
                }
              />
            </div>
          </RadioGroup>
        </FormControl>

        {/* Alerta de impuestos */}
        {props.mostrarAlertaImpuestos && (
          <div
            style={{
              marginTop: "1.5rem",
              padding: "1rem",
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: "5px",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: "0.5rem",
              }}
            >
              ATENCIÓN
            </div>

            <div>
              Si la entrega es realizada por Barbieri, el pedido estará sujeto
              al cargo correspondiente por embalaje y seguro.
            </div>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <button
          className="btn btn-danger"
          type="button"
          onClick={props.handleNext}
          disabled={props.esPedidoFirme === null}
          style={{
            backgroundColor: colores.rojo,
            padding: "0.625rem",
            marginTop: "1.25rem",
            inlineSize: "10rem",
            marginLeft: "1rem",
            color: "white",
          }}
        >
          CONTINUAR
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default connect()(PedidoFirme);
